import { Tooltip } from "@mui/material";
import { cloneElement, useRef, useState } from "react";

import type { FC, ReactElement, ReactNode, Ref } from "react";

/**
 * Shows its title only when its child is cut off, as by an ellipsis: the child itself, or the part
 * of it `labelSelector` picks out, such as a Chip's label.
 */
export const CutOffTooltip: FC<{
  title: ReactNode;
  labelSelector?: string;
  children: ReactElement<{ ref?: Ref<HTMLElement> }>;
}> = ({ title, labelSelector, children }) => {
  const ref = useRef<HTMLElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={title}
      open={open}
      // Measured on opening, not from the event, which React has cleared by the enter delay's end.
      onOpen={() => {
        const label = labelSelector ? ref.current?.querySelector(labelSelector) : ref.current;
        if (label) setOpen(label.scrollWidth > label.clientWidth);
      }}
      onClose={() => setOpen(false)}
    >
      {cloneElement(children, { ref })}
    </Tooltip>
  );
};
